module.exports = __webpack_public_path__ + "static/media/urlIcon.1415fba8.svg";